import React, { StrictMode, useState } from 'react'
import { unstableSetRender, ConfigProvider } from 'antd-mobile'; // Support since version ^5.40.0
import zhCN from 'antd-mobile/es/locales/zh-CN';
import arSA from 'antd-mobile/es/locales/ar-SA'
import enUS from 'antd-mobile/es/locales/en-US';
import { createRoot } from 'react-dom/client'
import './index.css'
import "./i18n"; // 必须在 React App 之前引入
import App from './App.tsx'
import './index.css';
import { initVW } from './utils/vw'
initVW(375)

const getBrowserLang = () => {
  const lang = navigator.language || "en";
  // const lang = "ar";
  // console.log("浏览器语言:", lang);
  const langVal = lang.toLowerCase();
  if (langVal.includes('zh')) {
    return zhCN;
  } else if (langVal.includes('ar')) {
    return arSA;
  } else if (langVal.includes('en')) {
    return enUS;
  }
};

// 创建语言上下文
const LocaleContext = React.createContext({
  locale: getBrowserLang() || zhCN,
  setLocale: (lang: string) => { }
});

function LocaleWrapper({ children }: { children: React.ReactNode }) {
  const [locale, setLocale] = useState(getBrowserLang() || zhCN);
  const updateLocale = (lang: string) => {
    switch (lang) {
      case 'ar':
        setLocale(arSA);
        break;
      case 'en':
        setLocale(enUS);
        break;
      default:
        setLocale(zhCN);
    }
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale: updateLocale }}>
      <ConfigProvider locale={locale}>
        {children}
      </ConfigProvider>
    </LocaleContext.Provider>
  );
}

unstableSetRender((node, container) => {
  container._reactRoot ||= createRoot(container);
  const root = container._reactRoot;
  root.render(node);
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    root.unmount();
  };
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LocaleWrapper>
      <App />
    </LocaleWrapper>
  </StrictMode>
)
